import React from "react";
import { jobsData } from "./jobsData";

const WhatWeDo = ({ handleScheduleClick }) => {
  return (
    <div className="with-navbar-offset">
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* What We Do Hero Section */}
      <section className="whatwedo-hero-section">
        <h1 className="whatwedo-hero-title">
          🛠️ What We Do: Top Handyman Jobs with Real Time & Price Estimates
        </h1>
        <div className="whatwedo-hero-subtitle">
          We've Completed Over 12,500 Appointments — Here's What Most People
          Call Us For
        </div>
        <div className="whatwedo-hero-desc">
          From drywall and door fixes to full pergolas and floor installs, we do
          real handyman work — not vague "we'll see what happens" jobs. Below is
          a curated list of our top services, along with estimated time, price,
          and common notes.
        </div>
        <div className="whatwedo-hero-cards-row">
          <div className="whatwedo-reminder-block">
            <div className="reminder-flex-row">
              <div className="reminder-label-col">
                <span className="reminder-pin">📌</span>
                <span className="reminder-title">Reminder:</span>
              </div>
              <ul className="reminder-list">
                <li>If it takes less time, you pay less.</li>
                <li>
                  If it takes more time, your handyman will explain why — before
                  moving forward.
                </li>
                <li>No surprise charges. No material markups.</li>
              </ul>
            </div>
          </div>
          <div className="whatwedo-alex-section">
            <div className="alex-chat-bubble">
              <div className="alex-chat-icon">💬</div>
              <div className="alex-chat-content">
                <div className="alex-chat-title">
                  Need help booking? Ask Alex.
                </div>
                <div className="alex-chat-desc">
                  Alex is our smart chatbot who can quote, schedule, and confirm
                  appointments 24/7.
                </div>
                <button className="alex-chat-cta" onClick={handleScheduleClick}>
                  �� Chat with Alex now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Most Requested Jobs Section */}
      <section className="whatwedo-jobs-section">
        <h2 className="jobs-section-title">
          🔧 Most Requested Jobs{" "}
          <span className="jobs-section-sub">(with Estimates)</span>
        </h2>
        <div className="jobs-table-wrapper">
          <table className="jobs-table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Avg Time</th>
                <th>Est. Price</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {jobsData.map((job, idx) => (
                <tr key={idx}>
                  <td>{job.service}</td>
                  <td>{job.avgTime}</td>
                  <td>{job.estPrice}</td>
                  <td>{job.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      {/* Specialty Services Section */}
      <section className="whatwedo-specialty-section">
        {/* Drywall Repairs */}
        <div className="specialty-block">
          <h3 className="specialty-title">
            🧱 Drywall Repairs{" "}
            <span className="specialty-sub">(Includes Patch Paint)</span>
          </h3>
          <div className="specialty-table-wrapper">
            <table className="specialty-table">
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Avg Time</th>
                  <th>Est. Price</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Small (&lt;6")</td>
                  <td>~1 hr</td>
                  <td>$79</td>
                  <td>Includes texture & touch-up</td>
                </tr>
                <tr>
                  <td>Medium (6–18")</td>
                  <td>1–1.5 hrs</td>
                  <td>$79–$110</td>
                  <td>Texture blending included</td>
                </tr>
                <tr>
                  <td>Large (18"+)</td>
                  <td>2–3.5 hrs</td>
                  <td>$140–$250</td>
                  <td>Includes patch paint & mudding</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Painting Labor */}
        <div className="specialty-block">
          <h3 className="specialty-title">
            🎨 Painting Labor{" "}
            <span className="specialty-sub">(Walls & Trim)</span>
          </h3>
          <div className="specialty-painting-desc">
            Flat labor pricing — you provide paint, we'll handle the rest.
          </div>
          <div className="specialty-painting-price">
            $1.50<span className="specialty-unit">/sq ft (labor only)</span>
          </div>
          <ul className="specialty-painting-list">
            <li>Includes minor prep, taping, cutting, and cleanup</li>
          </ul>
        </div>
        {/* Flooring Labor */}
        <div className="specialty-block">
          <h3 className="specialty-title">
            🧱 Flooring Labor{" "}
            <span className="specialty-sub">(Install Only)</span>
          </h3>
          <div className="specialty-table-wrapper">
            <table className="specialty-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Price per Sq Ft</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>LVP / Laminate</td>
                  <td>$3.50</td>
                  <td>Includes underlayment install</td>
                </tr>
                <tr>
                  <td>Tile Flooring</td>
                  <td>$5.50</td>
                  <td>Includes mortar & leveling</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="specialty-note">
            📌 Demo/removal priced separately. Call for full install packages.
          </div>
        </div>
        {/* Store Time for Materials */}
        <div className="specialty-block">
          <h3 className="specialty-title">🛒 Store Time for Materials</h3>
          <div className="specialty-store-desc">
            If you don't have materials onsite, we'll go pick them up for you.
          </div>
          <div className="specialty-store-price">
            Flat Add-On: <strong>+1 Hour of labor</strong>
          </div>
          <ul className="specialty-store-list">
            <li>Covers drive time, shopping, loading, and returning.</li>
          </ul>
        </div>
      </section>
      {/* Special Builds & Projects Section */}
      <section className="whatwedo-specialbuilds-section alt-style">
        <h3 className="specialbuilds-title">🏗️ Special Builds & Projects</h3>
        <div className="specialbuilds-table-wrapper alt-table">
          <table className="specialbuilds-table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Est. Time</th>
                <th>Typical Range</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Pergola Builds</td>
                <td>Half–Full Day</td>
                <td>$400–$800+</td>
                <td>2–4 person crew</td>
              </tr>
              <tr>
                <td>Shed Kits / Gazebos</td>
                <td>3–6 hrs</td>
                <td>$200–$500+</td>
                <td>Based on brand & instructions</td>
              </tr>
              <tr>
                <td>Trampoline/Playset</td>
                <td>2–5 hrs</td>
                <td>$150–$400</td>
                <td>Varies based on model</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="specialbuilds-info-inline">
          <span className="specialbuilds-info-title">
            💬 Don't See Your Job?
          </span>
          <span className="specialbuilds-info-desc">
            No problem. If it's handyman work — we probably do it.{" "}
            <span className="specialbuilds-info-cta">
              Ask Alex right now for a custom quote or call us directly.
            </span>
          </span>
        </div>
      </section>
      {/* Transparent Pricing Section */}
      <section className="whatwedo-pricing-section alt-style">
        <h3 className="pricing-title">💲 Transparent Pricing</h3>
        <div className="pricing-row alt-pricing-row">
          <div className="pricing-big">
            <span className="pricing-label">First Hour</span>
            <span className="pricing-value big">$79</span>
          </div>
          <div className="pricing-big">
            <span className="pricing-label">Every Additional Hour</span>
            <span className="pricing-value big">$69</span>
            <span className="pricing-sale">(limited-time sale)</span>
          </div>
        </div>
        <hr className="pricing-divider" />
        <div className="pricing-note alt-pricing-note">
          *No material markups. No hidden fees. No payment until you're happy.
        </div>
        <div className="pricing-trust alt-pricing-trust">
          ✅ Our handymen are full-time professionals who take pride in every
          job. And yes — most customers call us back multiple times a year.
        </div>
      </section>
    </div>
  );
};

export default WhatWeDo;
